<template>
    <div>
        <fieldset>
            <div style="padding: 20px;">
                <div class="row">
                  <div class="col-md-3">
                      <label for="template_nature">Template Nature</label>
                      <select id="template_nature" v-model="$parent.template.nature">
                        <option value="email">Email</option>
                        <option value="sms">SMS</option>
                      </select>
                  </div>
                  <div class="col-md-3" v-if="$parent.template.nature == 'email'">
                      <label for="template_type">Template Type</label>
                      <select id="template_type" v-model="$parent.template.template_type">
                        <option value="1">Admin Email</option>
                        <option value="2">System generated</option>
                      </select>
                  </div>
                  <div class="col-md-3">
                      <label for="template-name">Template Name</label>
                      <input type="text" id="template-name" placeholder="Template Name" v-model="$parent.template.template_name">
                  </div>
                  <div class="col-md-3" v-if="$parent.template.nature == 'email'">
                      <label for="template_subject">Template Subject</label>
                      <input id="template_subject" type="text" placeholder="Template Subject" v-model="$parent.template.template_subject">
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-3">
                    <label for="template_subject">Template Slug</label>
                      <input id="template_subject" class="gray-readonly-input" type="text" placeholder="Template Slug" v-model="$parent.template.template_slug">
                  </div>
                  <div class="col-md-4" v-if="$parent.template.nature == 'email'">
                    <v-select 
                      v-model="$parent.template.selected_doc_types" 
                      :options="documentTypes" 
                      multiple 
                      label="label"
                      placeholder="Attach Default document(s)" />
                  </div>
                  <div class="col-md-4">
                      <label for="status">Is Active</label>
                          <label class="switch">
                          <input id="is-active" type="checkbox" 
                                  v-model="$parent.template.template_status"
                                  :checked="($parent.template.template_status == 1) ? true : false">
                          <span class="switch__slider"></span>
                      </label>
                  </div>
                </div>

                <div class="row mt-4">
                    <div class="col-md-8" v-if="$parent.template.nature == 'email'">
                      <label for="template-name">Body Content</label>
                      <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(100% - 1rem); margin-top: 10px;">
                        <ckeditor
                          :key="$parent.template.nature + '-editor'"
                          :editor="editor"
                          v-model="$parent.template.template_body_content"
                          :config="editorConfig"
                          :height="300"
                          v-on:ready="onEditorReady"
                        />
                      </div>
                    </div>
                    <div class="col-md-8" v-else>
                        <label for="template-name">Body Content</label>
                        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(100% - 1rem); margin-top: 10px;">
                            <textarea ref="smsTextarea" v-model="$parent.template.template_body_content" 
                                      @input="validateGsm7Compatibility"
                                      style="width: 100%; height: 300px; padding: 10px; 
                                      font-size: 14px; border: 1px solid #ccc; border-radius: 4px; resize: vertical;">
                            </textarea>
                            <div v-if="nonGsm7Characters.length > 0" class="gsm-error">
                              <span>Non-GSM-7 characters detected: </span>
                              <span v-for="(char, index) in nonGsm7Characters" :key="index" class="invalid-char">{{char}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 content-variables" v-if="templateVariable.length > 0 ">
                      <label for="template-name"> Content Variables </label>
                      <ul style="margin-top: 10px;">
                        <li v-for="(tempVar, index) in templateVariable" :key="tempVar.variable || index">
                          <a class="button variable-button" v-on:click="insertDataAtCursor(tempVar.variable)"> {{ tempVar.name }} </a>
                        </li>
                      </ul>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
  </template>
  
<script>

  import CKEditor from '@ckeditor/ckeditor5-vue';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

  export default {

    name: 'EmailTemplateFields',
    components :{
        ckeditor: CKEditor.component
    },
    data () {
      return {
        editorInstance:null,
        editor: ClassicEditor,
        nonGsm7Characters: [],
        editorConfig: {
          toolbar: {
            items: [
              "heading",
              "bold",
              "italic",
              "link",
              "bulletedList",
              "numberedList",
              "blockQuote",
              "insertTable",
              "undo",
              "redo",
            ],
          },
          height:500
        },
        templateVariable:[
          {
            variable:'customer',
            name:"{{customer}}"
          },
          {
            variable:'customer_title',
            name:"{{customer_title}}"
          },
          {
            variable:'customer_firstname',
            name:"{{customer_firstname}}"
          },
          {
            variable:'customer_lastname',
            name:"{{customer_lastname}}"
          },
          {
            variable:'passenger_names',
            name:"{{passenger_names}}"
          },
          {
            variable:'booking_ref',
            name:"{{booking_ref}}"
          },
          {
            variable:'tour_destination',
            name:"{{tour_destination}}"
          },
          {
            variable:'hotel',
            name:"{{hotel}}"
          },
          {
            variable:'room_type',
            name:"{{room_type}}"
          },
          {
            variable:'board_basis',
            name:"{{board_basis}}"
          },
          {
            variable:'hotel_contact',
            name:"{{hotel_contact}}"
          },
          {
            variable:'hotel_address',
            name:"{{hotel_address}}"
          },
          {
            variable:'hotel_resort',
            name:"{{hotel_resort}}"
          },
          {
            variable:'accept_button',
            name:"{{accept_button}}"
          },
          {
            variable:'manage_booking',
            name:"{{manage_booking}}"
          },
          {
            variable:'departure_date',
            name:"{{departure_date}}"
          },
          {
            variable:'return_date',
            name:"{{return_date}}"
          },
          {
            variable:'outbound_flight_time',
            name:"{{outbound_flight_time}}"
          },
          {
            variable:'return_flight_time',
            name:"{{return_flight_time}}"
          },
          {
            variable:'outbound_departure_airport',
            name:"{{outbound_departure_airport}}"
          },
          {
            variable:'return_departure_airport',
            name:"{{return_departure_airport}}"
          },
          {
            variable:'tour_destination_name',
            name:"{{tour_destination_name}}"
          },
          {
            variable:'balance_due_date',
            name:"{{balance_due_date}}"
          },
          {
            variable:'tour_balance',
            name:"{{tour_balance}}"
          },
          {
            variable:'tour_covering_email',
            name:"{{tour_covering_email}}"
          },
          {
            variable:'airline_name',
            name:"{{airline_name}}"
          },
          {
            variable:'airline_reference',
            name:"{{airline_reference}}"
          },
          {
            variable:'airline_content',
            name:"{{airline_content}}"
          },
          {
            variable:'airline_reference_email',
            name:"{{airline_reference_email}}"
          },
          {
            variable:'flight_details',
            name:"{{flight_details}}"
          },
          {
            variable:'balance_due_content',
            name:"{{balance_due_content}}"
          },
          {
            variable:'documents_link',
            name:"{{documents_link}}"
          },

        ],
        documentTypes: [
          { label: 'Confirmation', doc: 'invoice' },
          { label: 'ATOL Certificate', doc: 'atol' },
          { label: 'Travel Itinerary', doc: 'airline' },
          { label: 'Airline Check-In Instructions', doc: 'airline-checkin' },
          { label: 'Agent invoice', doc: 'agent-invoice' },
          { label: 'Cancellation invoice', doc: 'cancellation-invoice' },
          { label: 'Additional Documents', doc: 'additional-documents' }
        ],
      }
    },
    watch: {
      '$parent.template.nature': {
        handler(newValue) {
          if (newValue === 'sms') {
            this.$nextTick(() => {
              this.validateGsm7Compatibility();
            });
          } else {
            // Clear any GSM-7 errors when switching to email
            this.nonGsm7Characters = [];
          }
        }
      }
    },
    methods: {
      onEditorReady(editor) {
        this.editorInstance = editor;
        // Set the editor content to match the template body content
        if (this.$parent && this.$parent.template && this.$parent.template.template_body_content) {
          editor.setData(this.$parent.template.template_body_content);
        }
      },
      validateGsm7Compatibility() {
        if (this.$parent.template.nature !== 'sms') return;
        
        // GSM-7 Basic Character Set
        const gsm7Charset = "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\x1BÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
        // GSM-7 Basic Character Set Extension (each costs 2 characters in message length)
        const gsm7ExtensionCharset = "^{}\\[~]|€";
        
        const text = this.$parent.template.template_body_content;
        const nonGsm7 = [];
        
        // Check each character in the text
        for (let i = 0; i < text.length; i++) {
          const char = text.charAt(i);
          if (!gsm7Charset.includes(char) && !gsm7ExtensionCharset.includes(char)) {
            if (!nonGsm7.includes(char)) {
              nonGsm7.push(char);
            }
          }
        }
        
        this.nonGsm7Characters = nonGsm7;
      },
      insertDataAtCursor(data) {
        const customText = `{{${data}}}`;

        if (this.editorInstance) {

          const model = this.editorInstance.model;
          const selection = model.document.selection;

          
          if (selection) {
            // Insert custom text at the cursor point
            this.editorInstance.model.change((writer) => {
              writer.insertText(customText, selection.getFirstPosition());
            });
            
          }
        } else {
          // For textarea (SMS templates), insert at cursor position using ref
          const textarea = this.$refs.smsTextarea;
          if (textarea) {
            const startPos = textarea.selectionStart;
            const endPos = textarea.selectionEnd;
            const textBefore = this.$parent.template.template_body_content.substring(0, startPos);
            const textAfter = this.$parent.template.template_body_content.substring(endPos);
            this.$parent.template.template_body_content = textBefore + customText + textAfter;
            // Set cursor position after inserted text
            this.$nextTick(() => {
              textarea.focus();
              textarea.selectionStart = textarea.selectionEnd = startPos + customText.length;
              // Run validation after insertion
              this.validateGsm7Compatibility();
            });
          }
        }
      }
    }
  }
</script>

<style scoped>
.content-variables li {
  margin-top: 10px;
}
.variable-button {
  text-transform:lowercase !important
}
.gray-readonly-input[readonly] {
    color: #666; /* Grey text color */
    background-color: #f9f9f9; /* Light grey background color */
    border-color: #ddd; /* Light grey border color */
}
.gsm-error {
  color: #dc3545;
  margin-top: 5px;
  font-size: 14px;
}
.invalid-char {
  background-color: #ffe6e6;
  border: 1px solid #ff8080;
  border-radius: 3px;
  padding: 2px 5px;
  margin: 0 3px;
  display: inline-block;
}
</style>

  